export enum SegmentationKey {
  CareTeamRole = "careTeamRoleSelection",
  RecommendedMessages = "shouldDisplayACPReplies",
  AssistantCoachLink = "showAssistantCoachLink",
  CoachCentricView = "shouldDisplayCoachCentricView",
  MessageTranslationSegment = "messageTranslationSegment",
  AccessManagement = "shouldDisplayAccessManagement"
}
